import { buildDispatchable } from '../../actions/_action-utilities';
import history from '../../history';
import { connect } from 'react-redux';
import ForgotPasswordForm from './forgot-password-form';
import { handleForgotPassword, initializeForgotPassword } from '../../actions/forgot-password';
const mapStateToProps = (props)=>{
    const { forgotPassword } = props;
    return {
        ...forgotPassword
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        handleUsernameSubmission: async (username)=>{
            runDispatchable(()=>{
                return dispatch(handleForgotPassword(username));
            });
        },
        handleCancel: ()=>{
            runDispatchable(()=>{
                history.push('/');
            });
        },
        initializeForgotPassword: ()=>{
            runDispatchable(()=>{
                return dispatch(initializeForgotPassword());
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordForm);
